module.exports = __webpack_public_path__ + "img/ni.ni97abb7c.svg";